import { __awaiter, __generator } from "tslib";
import axios from "axios";
import endpoints from "./endpoints";
import { addCustomHeaders } from "../utils/helpers/functions";
// Create Axios instance
console.log(process.env);
axios.defaults.withCredentials = true; // Enable sending cookies with requests
var axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 20000,
});
var isRefreshing = false;
var failedQueue = [];
var processQueue = function (error) {
    failedQueue.forEach(function (prom) {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve();
        }
    });
    failedQueue = [];
};
// Request Interceptor
axiosInstance.interceptors.request.use(function (config) {
    // No need to add token manually as it is handled by httpOnly cookies
    addCustomHeaders(config.headers);
    //addBypassHeaders(config.headers as Record<string, string>);
    return config;
}, function (error) {
    return Promise.reject(error);
});
// Response Interceptor
axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest;
    var _a;
    return __generator(this, function (_b) {
        originalRequest = error.config;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        failedQueue.push({ resolve: resolve, reject: reject });
                    })
                        .then(function () { return axiosInstance(originalRequest); })
                        .catch(function (err) { return Promise.reject(err); })];
            }
            originalRequest._retry = true;
            isRefreshing = true;
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    axios
                        .post(endpoints.api.refreshToken, {}, { withCredentials: true })
                        .then(function (res) {
                        if (res.status === 200) {
                            processQueue(null);
                            resolve(axiosInstance(originalRequest));
                        }
                        else {
                            processQueue(new Error("Refresh failed"));
                            window.location.href = endpoints.web.login;
                            reject(error);
                        }
                    })
                        .catch(function (err) {
                        processQueue(err);
                        window.location.href = endpoints.web.login; // Redirect to login page
                        reject(err);
                    })
                        .finally(function () {
                        isRefreshing = false;
                    });
                })];
        }
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
export default axiosInstance;
